import { WindowAccessor } from "../accessors/window.accessor";

export default class WindowMessageHelper {
  public static sendHeight(windowAccessor: WindowAccessor, height: number): void {
    const window = windowAccessor.get();

    if (!window) {
      return;
    }

    window.parent?.postMessage({
      levante: {
        height: height
      }
    }, "*"); 
  }

  public static sendNavigation(windowAccessor: WindowAccessor): void {
    const window = windowAccessor.get();

    if (!window) {
      return;
    }

    window.parent?.postMessage({
      levante: {
        navigation: true
      }
    }, "*");
  }

  public static getAppRootHeight(document: Document): number {
    const appRoot = document.getElementsByTagName('app-root')[0];
    return (appRoot as any).offsetHeight;
  }
}
